import React from 'react';
import { Routes, Route } from "react-router-dom";
import PrivateAuth from '../../authorization/PrivateAuth';
import OldGoldEntryList from '../../../pages/OldGoldEntry/OldGoldEntryList/OldGoldEntryList';
import CreateOldGoldEntry from '../../../pages/OldGoldEntry/CreateOldGoldEntry/CreateOldGoldEntry';


function OldGoldEntrytRoute() {
    // prefix of this route
    // melting
    return (
        <Routes>
            <Route element={<PrivateAuth />}>
                <Route path="/old-gold-entry-list" element={<OldGoldEntryList />} />

                <Route path="/old-gold-entry-create" element={<CreateOldGoldEntry />} />

                

            </Route>
        </Routes>
    );
}

export default OldGoldEntrytRoute;
